import { forwardRef, ReactNode, useCallback } from "react";

interface ScrollToOptions {
  top?: number;
  offset?: number;
  behavior?: "smooth";
  root?: Element;
}

export const useScroll = () => {
  const scrollToBottom = useCallback((options?: ScrollToOptions) => {
    if (typeof window !== "undefined") {
      const { height } = document.body.getBoundingClientRect();
      const offset = options?.offset ?? 0;
      const { ...rest } = options;

      window.scrollTo({ top: height + offset, behavior: "smooth", ...rest });
    }
  }, []);

  const scrollTo = useCallback((name: string, options?: ScrollToOptions) => {
    if (typeof window !== "undefined") {
      const root = options?.root ?? window;
      const ele = document.getElementById(`scrollable-${name}`);

      if (ele) {
        const offset = options?.offset ?? 0;
        const { ...rest } = options;
        const scrollToOptions: ScrollToOptions = {
          top: ele.offsetTop + offset,
          behavior: "smooth",
          ...rest,
        };

        if (root) {
          root.scroll(scrollToOptions);
        } else {
          window.scroll(scrollToOptions);
        }
      }
    }
  }, []);

  return {
    scrollToBottom,
    scrollTo,
  };
};

interface Props {
  name: string;
  className?: string;
  children: ReactNode;
}

export const Scrollable = forwardRef<HTMLDivElement, Props>(
  ({ name, className, children }, ref) => {
    return (
      <div ref={ref} id={`scrollable-${name}`} className={className}>
        {children}
      </div>
    );
  }
);

Scrollable.displayName = "Scrollable";
